import {url} from "../../utils/urls";
import {isEmpty, isNotEmpty} from "../../utils/strings";
import useAuth from "../../auth/useAuth";
import {isEmptyObject} from "../../utils/objects";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SwiperArrowLeft = ({swiper,isEnabled, ...props}) => {
  const {theme} = useAuth();
  return (
    isEmptyObject(swiper) ?
      <></>
      :
      <span
        {...props}
        className={
          "my-swiper-button-prev my-swiper-navi" +
          //(swiper?.isBeginning ? " disabled" : "")
          (isEnabled ? " disabled" : "")
        }
        aria-hidden="true"
        onClick={() => {
          swiper?.slidePrev();
        }}
      >
    {(isNotEmpty(theme) && theme === "black") ?
      <img src={url("/img/common/prev_white.png")} className="img-fluid" alt="next"/>
      :
      <img src={url("/img/common/prev_black.png")} className="img-fluid" alt="next"/>
    }
  </span>
  )
};
export default SwiperArrowLeft;